import logo2021 from "../../assets/img/nxtEvents/LogoStand&Deliver/Stand&Deliver.png";
import logo2022 from "../../assets/img/nxtEvents/LogoStand&Deliver/Stand&Deliver2022.png";
import logo2023 from "../../assets/img/nxtEvents/LogoStand&Deliver/Stand&Deliver2023.png";
import logo2024 from "../../assets/img/nxtEvents/LogoStand&Deliver/Stand&Deliver2024.png";
import logo2025 from "../../assets/img/nxtEvents/LogoStand&Deliver/Stand&Deliver2025.png";
import logo2026 from "../../assets/img/nxtEvents/LogoStand&Deliver/Stand&Deliver2026.png";

export const nxtStandAndDeliverDetail = {
  "nxt-stand-and-deliver": {
    id: "nxt-stand-and-deliver",
    title: "NXT Stand & Deliver",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-stand-and-deliver",
        items: [
          {
            id: "nxt-stand-and-deliver-2021",
            title: "TakeOver",
            description: "Stand & Deliver 2021",
            imgUrl: logo2021,
          },
          {
            id: "nxt-stand-and-deliver-2022",
            title: "Stand & Deliver",
            description: "2022",
            imgUrl: logo2022,
          },
          {
            id: "nxt-stand-and-deliver-2023",
            title: "Stand & Deliver",
            description: "2023",
            imgUrl: logo2023,
          },
          {
            id: "nxt-stand-and-deliver-2024",
            title: "Stand & Deliver",
            description: "2024",
            imgUrl: logo2024,
          },
          {
            id: "nxt-stand-and-deliver-2025",
            title: "Stand & Deliver",
            description: "2025",
            imgUrl: logo2025,
          },
          {
            id: "nxt-stand-and-deliver-2026",
            title: "Stand & Deliver",
            description: "ST. Louis 2026",
            imgUrl: logo2026,
          },
        ],
      },
    ],
  },
};
